import { $t } from '@teachino/shared-i18n';
import type { ValidatorRule } from '../validation-rules';

export type MaxLineLengthErrorMessageProps = {
  maxLength: number;
  offendingLine: string;
};

export type MaxLineLengthErrorMessageBuilder = (
  props: MaxLineLengthErrorMessageProps,
) => string;

export const makeValidateTextareaMaxLineLength =
  (
    maxLength: number,
    getErrorMessage?: MaxLineLengthErrorMessageBuilder,
  ): ValidatorRule =>
  (value: string) => {
    const offendingLine = value
      .split('\n')
      .find((line) => line.trim().length > maxLength);

    if (offendingLine !== undefined) {
      if (getErrorMessage) {
        return getErrorMessage({
          maxLength,
          offendingLine: offendingLine.trim(),
        });
      }

      return $t('generic_form_error.max_line_length', {
        maxLength: String(maxLength),
        line: offendingLine.trim(),
      });
    }

    return true;
  };
